module.exports = "/virtual-football-league/img/amblems/left/logos/Val.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Val.png
// module id = 2129
// module chunks = 4